import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function RoutedThroughCallRecording(_) {
    return _jsx(_Fragment, { children: "Record conversation" });
}
